/**
 * @file Constants used for hotelboard-indexeddb package
 */
/**
 * The name of the IndexedDB database
 */
export const IDB__DB_NAME = 'Hotelboard';
/**
 * Version of the database;
 * used for migration, and 'upgradeneeded' event will be called when this is changed
 */
export const IDB__VERSION = 1;
/**
 * Store that holds all the user preferences
 */
export const IDB__PREFERENCES__STORE = 'Preferences';
/**
 * value of the 'preference' key for color scheme setting
 */
export const IDB__PREFERENCES__COLOR_SCHEME = 'color-scheme';
/**
 * value of the 'preference' key for notification counter setting
 */
export const IDB__PREFERENCES__NOTIFICATION_COUNTER = 'notification-counter';
/**
 * All the stores in the database,
 * used to generate (and migrate) the database
 */
export const IDB__STORES_MAP = new Map([
    [IDB__PREFERENCES__STORE, {}],
]);
/**
 * The default database items scheme;
 * Used when none set in the db, or there was any error
 */
export const defaultDatabaseValues = {
    'color-scheme': 'light',
    'notification-counter': 0,
};
//# sourceMappingURL=constants.js.map